export default "__VITE_ASSET__BuQJscF0__$_?no-inline__"